import { render, staticRenderFns } from "./USU001_vistaPerfil.vue?vue&type=template&id=0ccfee9e&"
import script from "./USU001_vistaPerfil.vue?vue&type=script&lang=js&"
export * from "./USU001_vistaPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports